class CollapseDirective {
    constructor($document) {
        this.restrict = 'A';
        this.$document = $document;
    }

    link(scope, element, attrs, controllers) {
        if (attrs.collapse) {
            element.parent().attr('id', attrs.collapse);
        }

        let localStorageKey = 'collapse-' + element.parent().attr('id');

        if (localStorage.getItem(localStorageKey) === '1') {
            element.parent().children('.content').css('display', 'none');
        }

        element.on('click', () => {
            localStorageKey = 'collapse-' + element.parent().attr('id');
            localStorage.setItem(localStorageKey, element.parent().children('.content').css('display') !== 'none' ? '1' : '0');
            element.parent().children('.content').slideToggle('fast');
        });
    }

    static directiveFactory($document) {
        'ngInject';
        return new CollapseDirective($document);
    }
}

export default CollapseDirective;
